import * as type from './types';
import api from '../../../api';
import {GET_REGIONS_REFERENCES} from "./types";

const actions = {
    async getFuelProviderReferences({commit, dispatch}) {
        return await new Promise((resolve, reject) => {
            api.get(`fuel-provider-mapping/get-fuel-provider-all`)
                .then(res => {
                    commit(type.GET_FUEL_PROVIDER_REFERENCES, res.data);
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },
    async editFuelProviderReferences({commit, dispatch}, data) {
        return await new Promise((resolve, reject) => {
            api.patch(`fuel-provider-mapping/${data.id}/update-fuel-provider`, data.field)
                .then(res => {
                    dispatch('getFuelProviderReferences')
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },
    async addFuelProviderReferences({commit, dispatch}, data) {
        return await new Promise((resolve, reject) => {
            api.post(`fuel-provider-mapping/add-fuel-provider`, data)
                .then(res => {
                    dispatch('getFuelProviderReferences')
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },
    async removeFuelProviderReferences({commit, dispatch}, id) {
        return await new Promise((resolve, reject) => {
            api.delete(`fuel-provider-mapping/${id}/delete-fuel-provider`)
                .then(res => {
                    dispatch('getFuelProviderReferences')
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },

    async getFuelProviderPartnerReferences({commit, dispatch}) {
        return await new Promise((resolve, reject) => {
            api.get(`fuel-provider-partner-mapping/get-fuel-provider-all`)
                .then(res => {
                    commit(type.GET_FUEL_PROVIDER_PARTNER_REFERENCES, res.data);
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },
    async editFuelProviderPartnerReferences({commit, dispatch}, data) {
        return await new Promise((resolve, reject) => {
            api.patch(`fuel-provider-partner-mapping/${data.id}/update-fuel-provider`, data.field)
                .then(res => {
                    dispatch('getFuelProviderPartnerReferences')
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },
    async addFuelProviderPartnerReferences({commit, dispatch}, data) {
        return await new Promise((resolve, reject) => {
            api.post(`fuel-provider-partner-mapping/add-fuel-provider`, data)
                .then(res => {
                    dispatch('getFuelProviderPartnerReferences')
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },
    async removeFuelProviderPartnerReferences({commit, dispatch}, id) {
        return await new Promise((resolve, reject) => {
            api.delete(`fuel-provider-partner-mapping/${id}/delete-fuel-provider`)
                .then(res => {
                    dispatch('getFuelProviderPartnerReferences')
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },

    async getFuelTypesReferences({commit, dispatch}) {
        return await new Promise((resolve, reject) => {
            api.get(`fuel-type-mapping/get-fuel-type-all`)
                .then(res => {
                    commit(type.GET_FUEL_TYPES_REFERENCES, res.data);
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },
    async editFuelTypesReferences({commit, dispatch}, data) {
        return await new Promise((resolve, reject) => {
            api.patch(`fuel-type-mapping/${data.id}/update-fuel-type`, data.field)
                .then(res => {
                    dispatch('getFuelTypesReferences')
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },
    async addFuelTypesReferences({commit, dispatch}, data) {
        return await new Promise((resolve, reject) => {
            api.post(`fuel-type-mapping/add-fuel-type`, data)
                .then(res => {
                    dispatch('getFuelTypesReferences')
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },
    async removeFuelTypesReferences({commit, dispatch}, id) {
        return await new Promise((resolve, reject) => {
            api.delete(`fuel-type-mapping/${id}/delete-fuel-type`)
                .then(res => {
                    dispatch('getFuelTypesReferences')
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },

    async getRegionsReferences({commit, dispatch}) {
        return await new Promise((resolve, reject) => {
            api.get(`condition-mapping/get-condition-all`)
                .then(res => {
                    commit(type.GET_REGIONS_REFERENCES, res.data);
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },
    async editRegionsReferences({commit, dispatch}, data) {
        return await new Promise((resolve, reject) => {
            api.patch(`condition-mapping/${data.id}/update-condition`, data.field)
                .then(res => {
                    dispatch('getRegionsReferences')
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },
    async addRegionsReferences({commit, dispatch}, data) {
        return await new Promise((resolve, reject) => {
            api.post(`condition-mapping/add-condition`, data)
                .then(res => {
                    dispatch('getRegionsReferences')
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },
    async removeRegionsReferences({commit, dispatch}, id) {
        return await new Promise((resolve, reject) => {
            api.delete(`condition-mapping/${id}/delete-condition`)
                .then(res => {
                    dispatch('getRegionsReferences')
                    resolve(res);
                })
                .catch(error => {
                    console.log('Problem', error.message);
                    dispatch('showError', { errorMessage: error.response.data.message || error.message })
                    reject(error);
                });
        })
    },
    async getFuelProviderPartnersAZSReferences({commit, dispatch}) {
        return await new Promise((resolve, reject) => {
            api.get(`partner-gas-mapping`)
              .then(res => {
                  commit(type.GET_FUEL_PROVIDER_PARTNERS_AZS_REFERENCES, res.data);
                  resolve(res);
              })
              .catch(error => {
                  console.log('Problem', error.message);
                  dispatch('showError', { errorMessage: error.response.data.message || error.message })
                  reject(error);
              });
        })
    },
    async editFuelProviderPartnersAZSReferences({commit, dispatch}, data) {
        return await new Promise((resolve, reject) => {
            api.patch(`partner-gas-mapping/${data.id}/update-mapping`, data.field)
              .then(res => {
                  dispatch('getFuelProviderPartnersAZSReferences')
                  resolve(res);
              })
              .catch(error => {
                  console.log('Problem', error.message);
                  dispatch('showError', { errorMessage: error.response.data.message || error.message })
                  reject(error);
              });
        })
    },
    async addFuelProviderPartnersAZSReferences({commit, dispatch}, data) {
        return await new Promise((resolve, reject) => {
            api.post(`partner-gas-mapping/create-mapping`, data)
              .then(res => {
                  dispatch('getFuelProviderPartnersAZSReferences')
                  resolve(res);
              })
              .catch(error => {
                  console.log('Problem', error.message);
                  dispatch('showError', { errorMessage: error.response.data.message || error.message })
                  reject(error);
              });
        })
    },
    async removeFuelProviderPartnersAZSReferences({commit, dispatch}, id) {
        return await new Promise((resolve, reject) => {
            api.delete(`partner-gas-mapping/${id}/delete-mapping`)
              .then(res => {
                  dispatch('getFuelProviderPartnersAZSReferences')
                  resolve(res);
              })
              .catch(error => {
                  console.log('Problem', error.message);
                  dispatch('showError', { errorMessage: error.response.data.message || error.message })
                  reject(error);
              });
        })
    },
    async getGoldAZSReferences({commit, dispatch}) {
        return await new Promise((resolve, reject) => {
            api.get(`gold-gas-mapping`)
              .then(res => {
                  commit(type.GET_GOLD_AZS_REFERENCES, res.data);
                  resolve(res);
              })
              .catch(error => {
                  console.log('Problem', error.message);
                  dispatch('showError', { errorMessage: error.response.data.message || error.message })
                  reject(error);
              });
        })
    },
    async editGoldAZSReferences({commit, dispatch}, data) {
        return await new Promise((resolve, reject) => {
            api.patch(`gold-gas-mapping/${data.id}/update-mapping`, data.field)
              .then(res => {
                  dispatch('getGoldAZSReferences')
                  resolve(res);
              })
              .catch(error => {
                  console.log('Problem', error.message);
                  dispatch('showError', { errorMessage: error.response.data.message || error.message })
                  reject(error);
              });
        })
    },
    async addGoldAZSReferences({commit, dispatch}, data) {
        return await new Promise((resolve, reject) => {
            api.post(`gold-gas-mapping/create-mapping`, data)
              .then(res => {
                  dispatch('getGoldAZSReferences')
                  resolve(res);
              })
              .catch(error => {
                  console.log('Problem', error.message);
                  dispatch('showError', { errorMessage: error.response.data.message || error.message })
                  reject(error);
              });
        })
    },
    async removeGoldAZSReferences({commit, dispatch}, id) {
        return await new Promise((resolve, reject) => {
            api.delete(`gold-gas-mapping/${id}/delete-mapping`)
              .then(res => {
                  dispatch('getGoldAZSReferences')
                  resolve(res);
              })
              .catch(error => {
                  console.log('Problem', error.message);
                  dispatch('showError', { errorMessage: error.response.data.message || error.message })
                  reject(error);
              });
        })
    },

    async getStationCoordinatesAll({commit, dispatch}) {
        return await new Promise((resolve, reject) => {
            api.get(`station-coordinate/get-station-coordinate-all`)
              .then(res => {
                  commit(type.GET_STATION_COORDINATES, res.data);
                  resolve(res);
              })
              .catch(error => {
                  console.log('Problem', error.message);
                  dispatch('showError', { errorMessage: error.response?.data?.message || error.message })
                  reject(error);
              });
        })
    },

    async updateStationFranchise({dispatch}, data) {
        return await new Promise((resolve, reject) => {
            api.post(`station-coordinate/update-franchise`, data)
              .then(res => {
                  resolve(res);
              })
              .catch(error => {
                  console.log('Problem', error.message);
                  dispatch('showError', { errorMessage: error.response?.data?.message || error.message })
                  reject(error);
              });
        })
    },

    async getRoutePlannerFavorites({commit, dispatch}) {
        return await new Promise((resolve, reject) => {
            api.get(`route-planner/favorites`)
              .then(res => {
                  const list = Array.isArray(res.data)
                    ? res.data
                    : (Array.isArray(res.data?.data) ? res.data.data : []);
                  commit(type.GET_ROUTE_PLANNER_FAVORITES, list);
                  resolve(res);
              })
              .catch(error => {
                  console.log('Problem', error.message);
                  dispatch('showError', { errorMessage: error.response?.data?.message || error.message })
                  reject(error);
              });
        })
    },

    async createRoutePlannerFavorite({dispatch}, data) {
        return await new Promise((resolve, reject) => {
            api.post(`route-planner/favorites`, data)
              .then(res => {
                  dispatch('getRoutePlannerFavorites')
                  resolve(res);
              })
              .catch(error => {
                  console.log('Problem', error.message);
                  dispatch('showError', { errorMessage: error.response?.data?.message || error.message })
                  reject(error);
              });
        })
    },

    async updateRoutePlannerFavorite({dispatch}, { id, data }) {
        return await new Promise((resolve, reject) => {
            api.put(`route-planner/favorites/${id}`, data)
              .then(res => {
                  dispatch('getRoutePlannerFavorites')
                  resolve(res);
              })
              .catch(error => {
                  console.log('Problem', error.message);
                  dispatch('showError', { errorMessage: error.response?.data?.message || error.message })
                  reject(error);
              });
        })
    },

    async deleteRoutePlannerFavorite({dispatch}, id) {
        return await new Promise((resolve, reject) => {
            api.delete(`route-planner/favorites/${id}`)
              .then(res => {
                  dispatch('getRoutePlannerFavorites')
                  resolve(res);
              })
              .catch(error => {
                  console.log('Problem', error.message);
                  dispatch('showError', { errorMessage: error.response?.data?.message || error.message })
                  reject(error);
              });
        })
    },
};

export default actions;
